/**
 * Asynchronously loads Google Fonts WITHOUT blocking the initial render.
 *
 * Trick: inject the stylesheet with `media="print"` (so the browser does not
 * apply it / block render), then swap `media` back to `"all"` once the
 * stylesheet has loaded. Combined with `font-display: swap` in the URL,
 * the page renders instantly with system fallbacks and swaps to the
 * branded fonts as soon as they arrive.
 */
export function loadFonts() {
  if (typeof document === 'undefined') return
  if (document.getElementById('mp-google-fonts')) return

  // Preconnect to Google's font hosts to shave RTT.
  const preconnects = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
  ]
  preconnects.forEach((href) => {
    const l = document.createElement('link')
    l.rel = 'preconnect'
    l.href = href
    if (href.includes('gstatic')) l.crossOrigin = 'anonymous'
    document.head.appendChild(l)
  })

  const link = document.createElement('link')
  link.id = 'mp-google-fonts'
  link.rel = 'stylesheet'
  // Minimal set: only the weights actually used above the fold + an italic
  // for emphasis tags. Anything else falls back to system fonts gracefully.
  link.href =
    'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;1,400&family=Inter:wght@400&display=swap'
  link.media = 'print'
  link.onload = () => {
    link.media = 'all'
  }
  document.head.appendChild(link)
}
